import ShiftSwapPolicyCard from '../../components/settings/shift-swap-policy-card.tsx';
import { TeamSettingsFrame } from './team-hub.tsx';

/** /settings/team/swap-policy: who approves shift swaps. Staff portal only; the frame sends others to the roster. */
export default function TeamSwapPolicyPage() {
  return (
    <TeamSettingsFrame current="swapPolicy">
      <ShiftSwapPolicyCard />
    </TeamSettingsFrame>
  );
}
